export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8130.0fd56c2f.jpg";